import React from 'react';
import { createStyles, List } from '@material-ui/core';
import { DesktopMenuGroup } from './DesktopMenuGroup';
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';

const useStyles = makeStyles(
  (theme) =>
    createStyles({
      horizontalNavMenu: {
        position: 'relative',
        display: 'flex',
        marginLeft: 46,
        marginRight: -14,
        [theme.breakpoints.down('lg')]: {
          marginLeft: 15,
          marginRight: 0,
        },
      },
    }),
  { name: 'DesktopMenu' }
);

export const DesktopMenu = ({ menuItems }) => {
  const classes = useStyles();

  return (
    <List component="nav" disablePadding className={clsx(classes.horizontalNavMenu, 'Cmt-horizontalNavMenu')}>
      {menuItems.map((item, index) => (
        <DesktopMenuGroup {...item} key={index} />
      ))}
    </List>
  );
};
